// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__H3gb4","input__fullWidth":"Input_input__fullWidth__QP4UK"};